<template>
  <section class="social">
    <div class="container" :class="{ 'tiktok-hover': hoveredSocial === 'TikTok' }">
      <h2 class="titulo" :class="{ 'titulo-shift-right': hoveredSocial === 'TikTok' }">{{ $t('homePage.redes-sociais') }}</h2>
      <p class="descricao inter-regular">{{ $t('homePage.descrRedes') }}</p>
      <div class="social-buttons">
        <a
          v-for="(social, index) in socialLinks"
          :key="`${social.label}-${index}`"
          :href="social.url"
          target="_blank"
          rel="noopener noreferrer"
          class="social-button"
          @mouseenter="hoveredSocial = social.label"
          @mouseleave="hoveredSocial = ''"
          @focus="hoveredSocial = social.label"
          @blur="hoveredSocial = ''"
        >
          <img class="social-media" :src="logoRsGusMachado" :alt="social.label" />
          <span class="social-label">{{ social.label }}</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'
import logoRsGusMachado from '@/assets/logo-rs-gusmachado.jpg'

// Altere os links das redes sociais aqui.
const socialLinks = [
  { label: 'TikTok', url: 'https://www.tiktok.com/@_gusmachado' },
  { label: 'Instagram', url: 'https://www.instagram.com/_gusmachado' },
  { label: 'YouTube', url: 'https://www.youtube.com/channel/UCeJ7fXHX5sl8hLSJufdjiAw' },
  { label: 'Facebook', url: 'https://www.facebook.com/gusmontanharussa' }
]

const hoveredSocial = ref('')
</script>

<style scoped>
.social {
  min-height: 0;
  background: var(--color-bg-dark);
  color: var(--color-light);
  position: relative;
  overflow: hidden;
  padding-top: 8px;
  padding-bottom: 8px;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 40px 24px;
  text-align: left;
}

.titulo {
  margin: 0 0 10px;
  font-family: "Bebas Neue", sans-serif;
  font-size: 50px;
  font-weight: 400;
  transition: transform 0.45s ease, opacity 0.45s ease;
}

.titulo-shift-right {
  transform: translateX(240px);
  opacity: 0.25;
}

.descricao {
  margin: 0 0 20px;
  font-size: 20px;
  line-height: 1.5;
  transition: transform 0.45s ease, opacity 0.45s ease;
}

.container.tiktok-hover .descricao {
  transform: translateX(28px);
  opacity: 0.55;
}

.social-buttons {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  align-items: end;
  padding-top: 8px;
  padding-bottom: 8px;
}

.social-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  padding: 14px 16px;
  border: 1px solid rgba(229, 231, 235, 0.45);
  border-radius: 10px;
  color: var(--color-light);
  text-decoration: none;
  font-family: "Archivo", sans-serif;
  font-weight: 600;
  position: relative;
  overflow: visible;
  z-index: 1;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.social-media {
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  bottom: 66px;
  opacity: 0;
  transform: translate(-50%, 18px);
  transition: opacity 0.45s ease, transform 0.45s ease;
  pointer-events: none;
  z-index: 2;
}

.social-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  z-index: 2;
}

.social-button::before {
  content: '';
  position: absolute;
  left: -1px;
  right: -1px;
  bottom: -1px;
  height: 56px;
  border-radius: 10px;
  border: 1px solid transparent;
  background: transparent;
  z-index: -1;
  transition: height 0.45s ease, background 0.45s ease, border-color 0.45s ease;
}

.social-button:hover,
.social-button:focus-visible {
  color: var(--color-bg-dark);
  border-color: var(--color-light);
}

.social-button:hover .social-media,
.social-button:focus-visible .social-media {
  opacity: 1;
  transform: translate(-50%, 0);
}

.social-button:hover::before,
.social-button:focus-visible::before {
  height: 204px;
  background: var(--color-light);
  border-color: var(--color-light);
}

@media (aspect-ratio <= 3/4) {
  .titulo-shift-right {
    transform: translateX(110px);
  }

  .social-buttons {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
